<script>
  // Перенос src_ui/web/src/screens/Wiz.tsx — дословно.
  // Каркас визарда создания персонажа: шапка, степпер (аккаунт ✓ → личность → внешность), футер
  export let step = 1; // 1 — личность, 2 — внешность
  export let error = '';
  export let backHidden = false;
  export let onBack = () => {};
  export let nextLabel = '';
  export let nextDisabled = false;
  export let onNext = () => {};

  $: steps = [
    { n: 1, label: 'Аккаунт', state: 'stepdone' },
    { n: 2, label: 'Личность', state: step === 1 ? 'active' : 'stepdone' },
    { n: 3, label: 'Внешность', state: step === 2 ? 'active' : 'wait' },
  ];
</script>

<div class="wizpanel">
  <div class="wizcard">
    <div class="wizhead">
      <div class="t">Создание персонажа</div>
      <div class="s">Шаг {step + 1} / 3</div>
    </div>

    <div class="stepbar">
      {#each steps as s, i (s.n)}
        {#if i > 0}<div class="steplink"><div class="fill" style="transform:scaleX({s.state === 'wait' ? 0 : 1})"></div></div>{/if}
        <div class={'stepitem ' + s.state}>
          <div class="num">{s.state === 'stepdone' ? '✓' : s.n}</div>
          <div class="cap">{s.label}</div>
        </div>
      {/each}
    </div>

    <slot />

    {#if error}<div class="errtext" style="margin-top:12px">{error}</div>{/if}

    <div class="wizfoot">
      <div class={'back' + (backHidden ? ' hidden' : '')} on:click={onBack}>← Назад</div>
      <button class="btn-gold compact" disabled={nextDisabled} on:click={onNext}>{nextLabel}</button>
    </div>
  </div>
</div>
